import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertaService } from 'src/app/util/alerta.service';
import { functionHelper, functionUtil } from 'src/app/util/functionConst';
import { ParametrosConst } from 'src/app/util/parametrosConst';
import { ValidatorFunction } from 'src/app/util/validatorFunction';
import { IntranetService } from '../../intranet.service';
import { Parametro } from '../../model/parametro';
import { Contrasenia } from '../../model/usuario';
import { LoginService } from '../login.service';

@Component({
  selector: 'sura-cambiar-contrasenia',
  templateUrl: './cambiar-contrasenia.component.html',
  styleUrls: ['./cambiar-contrasenia.component.scss']
})
export class CambiarContraseniaComponent implements OnInit{
  hideActual = true;
  hideNueva = true;
  hideRepetir = true;
  contraseniaForm: FormGroup;
  listEstado: Parametro[] = [];
  longitudMinimaContrasenia: number;

  fnKeyDownPassword = functionUtil.fnKeyDownPassword;
  fnKeyDownPasswordMobile = functionUtil.fnKeyDownPasswordMobile;
  fnInputMaxLength = functionUtil.fnInputMaxLength;

  constructor(private _loginService: LoginService,
    private alertaService: AlertaService, private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private intranetService: IntranetService,
    private router: Router) {
this.initForm();
}

  ngOnInit(): void {
    this.longMinPwd().then(longitudMinimaContrasenia => {
      this.actualizarValidadoresFormulario(longitudMinimaContrasenia);
    }).catch(error => {
      this.alertaService.error('No se pudo cargar la longitud mínima de la contraseña.');
    });
  }

  private initForm(): void {
    this.contraseniaForm = this.formBuilder.group({
      contraseniaActual: ['', [Validators.required, Validators.minLength(ParametrosConst.PASS_LONGITUD_MIN)]],
      passwords: this.formBuilder.group({
        nuevaContrasenia: ['', [
          Validators.required,
          Validators.minLength(ParametrosConst.PASS_LONGITUD_MIN),
          ValidatorFunction.requiredNumero,
          ValidatorFunction.requiredMinuscula,
          ValidatorFunction.requiredMayuscula,
          ValidatorFunction.requiredCaracterEspecial
        ]],
        repetirContrasenia: ['', [Validators.required]]
      }, {validator: ValidatorFunction.repetirPassValidator})
    });
  }

  private actualizarValidadoresFormulario(longitudMinimaContrasenia: number): void {
    this.contraseniaForm.get('contraseniaActual').setValidators([
      Validators.required,
      Validators.minLength(longitudMinimaContrasenia)
    ]);
    this.contraseniaForm.get('passwords.nuevaContrasenia').setValidators([
      Validators.required,
      Validators.minLength(longitudMinimaContrasenia),
      ValidatorFunction.requiredNumero,
      ValidatorFunction.requiredMinuscula,
      ValidatorFunction.requiredMayuscula,
      ValidatorFunction.requiredCaracterEspecial
    ]);
    this.contraseniaForm.updateValueAndValidity();
  }

  longMinPwd(): Promise<number> {
    return this.intranetService.obtenerParametro(ParametrosConst.LONG_MIN_PWD).then(resultado => {
      if (resultado instanceof Array && resultado.length > 0) {
        const descripcionInt = parseInt(resultado[0].descripcion, 10);
        if (!isNaN(descripcionInt)) {
          return descripcionInt;
        } else {
          throw new Error('La descripción no es un número');
        }
      } else {
        throw new Error('El resultado no es un array o está vacío');
      }
    }).catch(error => {
      this.alertaService.error(error);
      throw error;
    });
  }

  enviarFormulario() {
    if (this.contraseniaForm.valid) {
      const form = this.contraseniaForm.getRawValue();
      const contrasenia = new Contrasenia();
      contrasenia.usuario = '';
      contrasenia.password = form.contraseniaActual;
      contrasenia.newpassword = form.passwords.nuevaContrasenia;
      this._loginService.cambiarContrasenia(contrasenia).then(response => {
        this._loginService.logout();
        this.alertaService.success(response);
        setTimeout(() => {
          this.router.navigate(['/ingreso']);
        }, ParametrosConst.TIEMPO_DURACION_ALERTA);
      }).catch(error => {
        this.alertaService.error(error);
      });
    }
  }

  obtenerMensajeError(controlName: string) {
    if (controlName === 'nuevaContrasenia' || controlName === 'repetirContrasenia') {
      const formGr = this.contraseniaForm.controls.passwords as FormGroup;
      return functionHelper.extraerErrorGroup(formGr, controlName);
    } else {
      return functionHelper.extraerErrorGroup(this.contraseniaForm, controlName);
    }
  }

  cancelar() {
    this.router.navigate([this.route.snapshot.queryParams.returnUrl]);
  }

  hasErrorGroup() {
    const formGr = this.contraseniaForm.controls.passwords as FormGroup;
    return formGr.hasError('equalsPassword') && !this.hasError('repetirContrasenia') && !this.hasError('nuevaContrasenia');
  }

  hasError(controlName: string) {
    try {
      if (controlName === 'nuevaContrasenia' || controlName === 'repetirContrasenia') {
        const formGr = this.contraseniaForm.controls.passwords as FormGroup;
        return formGr.controls[controlName].invalid;
      }
    } catch (error) {
      this.alertaService.error(error);
    }
  }
}
